import { Navigate, useLocation } from 'react-router-dom';
import { LocalStorage } from './utils/storage/local-storage';
import { CommonHelper } from './utils/commonHelper';
import { useEffect, useState } from 'react';
import HttpServices from './services/httpService';
import { userModuleURL } from './services/urlService';
import Spinner from './utils/Loader/spinner';
import {
  getStoredGetStartedChecklist,
  isGetStartedComplete,
  normalizeGetStartedChecklist,
} from './pages/get-started/getStartedShared';

const PrivateRouteComponent = ({ children, permissions }) => {
  const location = useLocation();
  const [setupChecked, setSetupChecked] = useState(false);
  const [setupChecklist, setSetupChecklist] = useState(null);
  let authUser = LocalStorage.getItem('token');
  let isRouteLoaded = LocalStorage.getItem('isRouteLoaded');

  useEffect(() => {
    if (!authUser || location.pathname === '/get-started') {
      setSetupChecked(true);
      return;
    }

    const storedChecklist = getStoredGetStartedChecklist();
    if (storedChecklist) {
      setSetupChecklist(storedChecklist);
      setSetupChecked(true);
      return;
    }

    setSetupChecked(false);
    HttpServices.Get({
      url: userModuleURL.getStartedChecklist,
      successCallback: (data) => {
        const normalized = normalizeGetStartedChecklist(data);
        LocalStorage.setItem('get_started', JSON.stringify(normalized));
        setSetupChecklist(normalized);
        setSetupChecked(true);
      },
      failureCallback: () => {
        setSetupChecked(true);
      },
    });
  }, [authUser, location.pathname]);

  if (authUser) {
    if (isRouteLoaded && JSON.parse(isRouteLoaded)) {
      if (location.pathname !== '/get-started' && CommonHelper.ShouldBlockAppForBilling()) {
        return <Navigate to="/get-started?step=payment&mode=plan-over" replace state={{ from: location }} />;
      }

      if (!setupChecked) {
        return <Spinner />;
      }

      if (setupChecklist && location.pathname !== '/get-started' && !isGetStartedComplete(setupChecklist)) {
        return <Navigate to="/get-started" replace state={{ from: location }} />;
      }

      if (permissions) {
        let permissionObj = CommonHelper.GetBrandInfoFromLocalStorage('permissions');
        if (permissionObj && permissionObj[permissions]) {
          return children;
        } else {
          return <Navigate to={CommonHelper.GetDefaultPermissionRoute(permissionObj)} />;
        }
      } else {
        //If permission is empty then the route is no-brand, no-organization
        return <Navigate to="/no-brand" />;
      }
    }
  } else {
    return <Navigate to="/login" />;
  }
};
export default PrivateRouteComponent;
